export const closedCirclesListActionsEnum = {
  approve: 1,

  getKeyByValue(value) {
    return Object.keys(this).find(key => this[key] === value);
  },
};
